import TemplateRegistry from '@lit-any/core/template-registry';
import TemplateSelectorBuilder from './TemplateSelectorBuilder';
// eslint-disable-next-line max-len
export default class ViewTemplateRegistry extends TemplateRegistry {
    _createBuilder() {
        return new TemplateSelectorBuilder(this);
    }
}
//# sourceMappingURL=TemplateRegistry.js.map